import { Box, CheckboxPillGroup, type CheckboxPillOption } from '@tempmee/react';
import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useAppSelector } from '~/hooks/useAppSelector';
import type { ISignUpFormValues } from '../../types';
import { SectionHeading } from './SectionHeading';

const SECTION_GAP = 32;
const HEADING_MARGIN_BOTTOM = 16;
const toPill = (label: string): CheckboxPillOption => ({ label, value: label });

export const InsuranceSection = () => {
  const { control, formState } = useFormContext<ISignUpFormValues>();

  const insurances = useAppSelector(
    (state) =>
      (state.user.officeEducation as { insurances?: string[] | null } | null | undefined)
        ?.insurances,
  );

  const options = useMemo<CheckboxPillOption[]>(
    () => (insurances ?? []).map(toPill),
    [insurances],
  );

  return (
    <Box style={{ marginTop: SECTION_GAP }}>
      <SectionHeading marginBottom={HEADING_MARGIN_BOTTOM}>
        Which Insurance Providers Do You Accept?
      </SectionHeading>
      <Controller
        name="insurances"
        control={control}
        rules={{ validate: (value) => Array.isArray(value) && value.length > 0 }}
        render={({ field }) => (
          <CheckboxPillGroup
            data-cy="checkbox-group-insurances"
            options={options}
            value={field.value}
            onChange={field.onChange}
            hasError={Boolean(formState.errors.insurances)}
          />
        )}
      />
    </Box>
  );
};
